const observeCookieBanner = () => {
    const targetId = 'cookieconsent:desc';

    const observer = new MutationObserver((mutations, obs) => {
        const targetSpan = document.getElementById(targetId);

        if (targetSpan) {
            const link = targetSpan.querySelector('a');

            if (link) {
                const cookiePopup = document.querySelector('.cookie-popup');
                const cookiePopupWrapper = cookiePopup?.querySelector('.cookie-popup__wrapper');
                const cookiePopupCloseBtn = cookiePopup?.querySelector('.cookie-popup__close');

                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (cookiePopup) {
                        cookiePopup.classList.add('open');
                    }
                });

                cookiePopupCloseBtn?.addEventListener('click', () => {
                    cookiePopup.classList.remove('open');
                });

                document.addEventListener('click', (e) => {
                    if (
                        cookiePopup?.classList.contains('open') &&
                        !cookiePopupWrapper.contains(e.target) &&
                        !link.contains(e.target)
                    ) {
                        cookiePopup.classList.remove('open');
                    }
                });

                obs.disconnect();
            }
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
};

observeCookieBanner();
